import React from "react";
import TableView from "../../tables/TableView";
import AddNewButton from "../../buttons/AddNewButton";
import useTableData from "../useTableData";
import ListViewCommon from "../ListViewCommon";

const headers = [
    {"label": "Stav", "caption": "Stav", 'filter': 'string'},
    {"label": "Kategoria", "caption": "Kategória", 'filter': 'string'},
    {"label": "Uzavrety", "caption": "Uzavretý", 'filter': 'bool'},
    {"label": "Farba", 'filter': 'string'}
]

function ServiceCaseStates(props) {
    const initialFilters = [
        {
            'label': 'Stav',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Kategoria',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Uzavrety',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Farba',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Stav',
        }
    ]
    const baseUrl = '/service_case/service_cases_states'
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'Stav': `/service_case_states/service_case_state/${entry.id}`
        }))
    }

    function colorize() {
        const rows = document.getElementsByTagName("tr")
        const new_rows = Array.from(rows)
        new_rows.splice(0,1)
        new_rows.forEach(row => {
            const cell = row.getElementsByTagName("td")[2]
            const color = cell.innerText
            cell.style.backgroundColor = color
        })
    }

    React.useEffect(() => {
        colorize()
    }, [data])

    return (
        <ListViewCommon baseUrlFrontend={`/service_case_states/service_case_state`}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Stavy servisných prípadov"}
        />
        // <div>
        //     <TableView links={links} headers={headers} data={data} delete_single={delete_single} label="Stavy servisných prípadov"/>
        //     <AddNewButton link={`/service_case_states/service_case_state/new`}/>
        // </div>
    )
}

export default ServiceCaseStates
